module.exports = __webpack_public_path__ + "fonts/329ae1c.ttf";